import { gql } from '@apollo/client';
import type { ScanPromptInfo } from '../../pages/pda/scanResult';

/** 轻量查询：仅包牌基础信息，不拉订单列表，用于PDA装包扫描等高频场景 */
export const GET_BAG_BASIC_INFO_BY_NUMBER_OLD = gql`
  query GetBagBasicInfoByNumberOld($bagNumber: String!) {
    getBagBasicInfoByNumberOld(bagNumber: $bagNumber) {
      id
      bagNumber
      businessType
      fromLocation
      nextStop
      sortingCode
      status
      carrierCode
      printType
      warehouseId
      promptSortingCode
      ttBizType
      success
      message
      promptInfo {
        messageKey
        popupType
        title
        content
      }
    }
  }
`;

/** getBagBasicInfoByNumber 响应（字段打平，与后端 BagBasicInfoResponse 对齐） */
export interface OldBagBasicInfoType {
  success: boolean;
  message?: string | null;
  id?: string | null;
  bagNumber?: string | null;
  businessType?: number | null;
  fromLocation?: string | null;
  nextStop?: string | null;
  sortingCode?: string | null;
  status?: number | null;
  carrierCode?: number | null;
  /** 打印模板类型 1-SwiftX 2-TT */
  printType?: number | null;
  /** 创建站点ID */
  warehouseId?: number | null;
  /** 展示用分拣段码：SWX/TEMU 取 sortingCode，TT 取第一分拣规则（有预分拣码时拼接为一个字段，如 LAX1-LAX1-UNI-UNI_SEA01） */
  promptSortingCode?: string | null;
  /** TT分拣业务类型：FBT/CBT/UNLIMITED(不限)；null=存量包牌/非TT */
  ttBizType?: string | null;
  promptInfo?: ScanPromptInfo | null;
}

/** 尾程商选项，与后端 CarrierOptionType 对应 */
export interface CarrierOptionType {
  value: number;
  name: string;
}

/** 获取尾程商选项列表（WarehouseQuery.getAllCarrierOptions） */
export const GET_ALL_CARRIER_OPTIONS = gql`
  query GetAllCarrierOptions {
    getAllCarrierOptions {
      value
      name
    }
  }
`;

export interface GetAllCarrierOptionsResponse {
  getAllCarrierOptions: CarrierOptionType[];
}

/** 0-未使用 1-已使用 2-已废弃 3-已使用(尾程交接) */
export const BAG_STATUS_DISCARDED = 2;
export const BAG_STATUS_HANDOVER = 3;

export interface GetBagBasicInfoByNumberOldResponse {
  getBagBasicInfoByNumberOld: OldBagBasicInfoType | null;
}

export interface GetBagBasicInfoByNumberVariables {
  bagNumber: string;
}

/** 装包扫描候选包牌：与后端 BaggingScanCandidateBagInput 对应 */
export interface OldBaggingScanCandidateBagInput {
  bagNumber: string;
  sortingCode: string;
  carrierCode?: number | null;
}

/** 装包扫描：后端匹配段码，直接返回 BaggingScanResponse（无外壳包裹） */
export const HANDLE_WHS_BAGGING_SCAN_EVENT = gql`
  mutation HandleWhsBaggingScanOldEvent($trackingNumber: String!, $candidateBags: [OldBaggingScanCandidateBagInput!]!, $clientReportKey: String) {
    result: handleWhsBaggingScanOldEvent(trackingNumber: $trackingNumber, candidateBags: $candidateBags, clientReportKey: $clientReportKey) {
      success
      message
      matchedBagNumber
      promptInfo {
        messageKey
        popupType
        title
        content
      }
    }
  }
`;

/** 旧版前端 gql（仅传 bagNumber，灰度兼容用） */
export const HANDLE_WHS_BAGGING_SCAN_EVENT_LEGACY = gql`
  mutation HandleWhsBaggingScanEvent($bagNumber: String!, $trackingNumber: String!, $clientReportKey: String) {
    result: handleWhsBaggingScanEvent(bagNumber: $bagNumber, trackingNumber: $trackingNumber, clientReportKey: $clientReportKey) {
      success
      message
      matchedBagNumber
      promptInfo {
        messageKey
        popupType
        title
        content
      }
    }
  }
`;

export interface HandleWhsBaggingScanEventVariables {
  trackingNumber: string;
  candidateBags: OldBaggingScanCandidateBagInput[];
  clientReportKey?: string;
}

export interface HandleWhsBaggingScanEventLegacyVariables {
  bagNumber: string;
  trackingNumber: string;
  clientReportKey?: string;
}

// 与后端 BaggingScanResponse 对齐：mutation 直接返回 BaggingScanResponse，无外壳包裹
export interface BaggingScanOldResponse {
  success: boolean;
  matchedBagNumber?: string | null;
  promptInfo?: ScanPromptInfo | null;
  message?: string | null;
}

export interface HandleWhsBaggingScanEventOldResponse {
  result: BaggingScanOldResponse;
}